import axios from 'axios';

export const getConsentGrantStatus = (ssoToken: string, corpAcctNbr: string) =>
  axios.get('/rest-api/five9-integration-service/v1/five9/consent/current', {
    headers: {
      'Content-Type': 'application/json',
      'nextiva-context-corpAcctNumber': `${corpAcctNbr}`,
      Authorization: `Bearer ${ssoToken}`,
    },
    withCredentials: true,
  });

export const saveConsentGrantStatus = (ssoToken: string, corpAcctNbr: string) =>
  axios.post(
    '/rest-api/five9-integration-service/v1/five9/consent/current',
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        'nextiva-context-corpAcctNumber': `${corpAcctNbr}`,
        Authorization: `Bearer ${ssoToken}`,
      },
      withCredentials: true,
    },
  );
